var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 29.333a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z",
    stroke: "url(#cart_svg__mobile-paint0_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 29.333a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z",
    stroke: "url(#cart_svg__mobile-paint1_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 1.333h5.334l3.573 17.854a2.667 2.667 0 002.667 2.146h12.96a2.667 2.667 0 002.666-2.146L30.667 8H8",
    stroke: "url(#cart_svg__mobile-paint2_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cart_svg__mobile-paint0_linear",
    x1: 10.667,
    y1: 29.333,
    x2: 13.87,
    y2: 28.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cart_svg__mobile-paint1_linear",
    x1: 25.333,
    y1: 29.333,
    x2: 28.536,
    y2: 28.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cart_svg__mobile-paint2_linear",
    x1: 1.333,
    y1: 21.334,
    x2: 32.809,
    y2: 5.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgCart;